<template>
  <div class="bx-content bx-content__continuous-text bx-typo--content-continuous-text">
    <form class="bx-form bx-typo--form bx-form--pur bx-typo--form-contact bx-form--alc-calc">
      <div class="bx-content__interline bx-typo--content-interline ">
        Angaben zur Person
      </div>
      <div class="bx-form__section bx-form__section--border">
        <div class="bx-form__select-wrapper">
          <label class="bx-form__label"
                 :class="{ 'bx-has-error': errors.gender }"
                 for="gender">
            Geschlecht
            <span class="bx-form__required"
                  title="Diese Angabe wird benötigt.">* </span>
          </label>
          <select id="gender"
                  v-model="person.gender"
                  class="bx-form__select"
                  :class="{ 'bx-has-error': errors.gender }">
            <option disabled
                    value="">
              Bitte wählen
            </option>
            <option value="male">
              Mann
            </option>
            <option value="female">
              Frau
            </option>
          </select>
          <Icon name="arrow_toggle" />
        </div>
        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.age }"
               for="person_age">
          Alter
          <span class="bx-form__required"
                title="Diese Angabe wird benötigt.">* </span>
        </label>
        <input id="person_age"
               v-model="person.age"
               type="number"
               placeholder="in Jahren"
               :class="{ 'bx-has-error': errors.age }"
               @keydown="preventNonPositiveNumberKeys">

        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.height }"
               for="person_height">
          Größe
          <span class="bx-form__required"
                title="Diese Angabe wird benötigt.">* </span>
        </label>
        <input id="person_height"
               v-model="person.height"
               placeholder="in cm"
               type="number"
               :class="{ 'bx-has-error': errors.height }"
               @keydown="preventNonPositiveNumberKeys">

        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.weight }"
               for="person_weight">
          Gewicht
          <span class="bx-form__required"
                title="Diese Angabe wird benötigt.">* </span>
        </label>
        <input id="person_weight"
               v-model="person.weight"
               placeholder="in kg"
               type="number"
               :class="{ 'bx-has-error': errors.weight }"
               @keydown="preventNonPositiveNumberKeys">
      </div>

      <div class="bx-content__interline bx-typo--content-interline ">
        Konsumierte Alkoholmenge
      </div>

      <div class="bx-form__section bx-form__section--border">
        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.beer }"
               for="alcohol_beer">Bier (5% vol.)</label>
        <input id="alcohol_beer"
               v-model="alcohol.beer"
               placeholder="in l"
               :class="{ 'bx-has-error': errors.beer }"
               type="number"
               @keydown="preventNonPositiveNumberKeys">

        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.wine }"
               for="alcohol_wine">Wein (10% vol.)</label>
        <input id="alcohol_wine"
               v-model="alcohol.wine"
               placeholder="in l"
               :class="{ 'bx-has-error': errors.wine }"
               type="number"
               @keydown="preventNonPositiveNumberKeys">

        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.liqueur }"
               for="alcohol_liqueur">Likör (25% vol.)</label>
        <input id="alcohol_liqueur"
               v-model="alcohol.liqueur"
               placeholder="in cl"
               :class="{ 'bx-has-error': errors.liqueur }"
               type="number"
               @keydown="preventNonPositiveNumberKeys">

        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.schnapps }"
               for="alcohol_schnapps">Schnaps (40% vol.)</label>
        <input id="alcohol_schnapps"
               v-model="alcohol.schnapps"
               placeholder="in cl"
               :class="{ 'bx-has-error': errors.schnapps }"
               type="number"
               @keydown="preventNonPositiveNumberKeys">
      </div>

      <div class="bx-content__interline bx-typo--content-interline ">
        Zeitraum des Alkoholkonsums
      </div>

      <div class="bx-form__section">
        <label class="bx-form__label"
               :class="{ 'bx-has-error': errors.duration }"
               for="duration">
          Dauer
          <span class="bx-form__required"
                title="Diese Angabe wird benötigt.">* </span>
        </label>
        <input id="duration"
               v-model="duration"
               placeholder="in Minuten"
               type="number"
               :class="{ 'bx-has-error': errors.duration }"
               @keydown="preventNonPositiveNumberKeys">
      </div>

      <div v-if="hasError"
           id="error-msg-wrapper"
           class="bx-has-error">
        <span v-if="errors.required"
              class="bx-form__message bx-form__message--error">
          Bitte alle Pflichtfelder ausfüllen.
        </span>
        <span v-if="errors.number"
              class="bx-form__message bx-form__message--error">
          Ungültige Zahleneingabe.
        </span>
      </div>

      <button id="calculate_alcohol"
              class="bx-form__button"
              @click.prevent="validateData(true)">
        Berechnen
      </button>

      <div class="bx-form__disclaimer-required">
        * Pflichtfelder
      </div>

      <div v-if="!resultHidden"
           class="bx-form__result">
        <div class="bx-content__interline bx-typo--content-interline ">
          Ergebnis: {{ result }} ‰
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { ref } from 'vue'

import EventBus from '../../../../event-bus/EventBus'
import { useAdaMoltenBundle } from '../../../../composables/use-ada-molten-bundle'
import { isValidPositiveDecimalInput, preventNonPositiveNumberKeys } from '.././../../../utils/validation/number'
import { useDeviceDetection } from '../../../../composables/use-device-detection'
import { useConfigStore } from '../../../../stores/config'
import Icon from '../../../../components/shared/Icon.vue'

export default {
  name: 'AlcoholCalculator',
  components: {
    Icon
  },
  setup () {
    const { deviceType, ...deviceDetection } = useDeviceDetection()
    const registerSlots = ref([])
    const moltenBundle = useAdaMoltenBundle({ registerSlots, deviceType })
    return { ...deviceDetection, deviceType, registerSlots, ...moltenBundle, isValidPositiveDecimalInput, preventNonPositiveNumberKeys }
  },
  data () {
    return {
      person: { gender: '', age: '', height: '', weight: '' },
      alcohol: { beer: '', wine: '', liqueur: '', schnapps: '' },
      duration: '',
      result: '',
      resultHidden: true,
      hasError: false,
      errors: this.initErrors(),
      alcoholVolume: { beer: 5, wine: 10, liqueur: 25, schnapps: 40 }
    }
  },
  computed: {
    ...mapState(useConfigStore, ['rsConfig']),
    reloadConfig () {
      return { ...this.rsConfig.adSlotUsage.reloadAdsOnInteraction.config, ...{ minDisplayDuration: 0, clickCount: 1 } }
    }
  },
  watch: {
    person: {
      deep: true,
      handler () {
        this.hideResult()
      }
    },
    alcohol: {
      deep: true,
      handler () {
        this.hideResult()
      }
    },
    duration () {
      this.hideResult()
    }
  },
  methods: {
    hideResult () {
      this.resultHidden = true
    },
    initErrors () {
      return {
        required: false,
        number: false,
        gender: false,
        age: false,
        height: false,
        weight: false,
        duration: false
      }
    },
    validateData (calculate) {
      this.hasError = false
      this.errors = this.initErrors()
      this.resultHidden = true

      const validateFields = [
        ['gender', this.person.gender],
        ['age', this.person.age],
        ['height', this.person.height],
        ['weight', this.person.weight],
        ['beer', this.alcohol.beer],
        ['wine', this.alcohol.wine],
        ['liqueur', this.alcohol.liqueur],
        ['schnapps', this.alcohol.schnapps],
        ['duration', this.duration]
      ]

      const requiredFields = ['gender', 'age', 'height', 'weight', 'duration']

      let errorEmpty = false
      let errorFormat = false

      validateFields.forEach(([field, value]) => {
        if (requiredFields.includes(field) && value === '') {
          this.errors[field] = true
          errorEmpty = true
        } else if (field !== 'gender' && value !== '' && !this.isValidPositiveDecimalInput(value)) {
          this.errors[field] = true
          errorFormat = true
        }
      })

      this.hasError = errorEmpty || errorFormat
      this.errors.required = errorEmpty
      this.errors.number = errorFormat

      if (!this.hasError && calculate) this.calculateAlcohol()
    },
    calculateAlcohol () {
      const alcoholDensity = 0.08
      const { gender, age, height, weight } = this.person
      const duration = this.duration

      const alcoholGrams = Object.entries(this.alcohol).reduce((sum, [key, value]) => {
        const amount = value
        if (!amount || amount <= 0) return sum
        if (key === 'beer' || key === 'wine') return sum + amount * 100 * this.alcoholVolume[key] * alcoholDensity
        return sum + amount * this.alcoholVolume[key] * alcoholDensity
      }, 0)

      const ageF = age; const heightF = height; const weightF = weight
      const totalBodyWater = gender === 'male'
        ? 2.447 - 0.09156 * ageF + 0.1074 * heightF + 0.3362 * weightF
        : 0.203 - 0.07 * ageF + 0.1069 * heightF + 0.2466 * weightF

      const resorption = 0.15 * (duration / 60)
      const result = Math.max(0, (0.8 * alcoholGrams) / (1.055 * totalBodyWater) - resorption)

      this.result = result.toFixed(2).replace('.', ',')
      this.resultHidden = false

      EventBus.$emit('triggerAGF')
      this.adaSlotReloadOnInteraction(this.reloadConfig)
    }
  }
}

</script>
